// visa.js

const visa = {
  id: 3,
  title: "Visa Assistance",
  questions: [
    {
      question: "Do you provide visa assistance services?",
      answer:
        "Yes, we assist with tourist, business, and group travel visa applications for multiple countries.",
    },
    {
      question: "Can you help with visa documentation?",
      answer:
        "Yes, we guide you through the complete documentation process including forms, bank statements, and travel proofs.",
    },
    {
      question: "Do you guarantee visa approval?",
      answer:
        "Visa approvals depend on embassy decisions, but we ensure proper documentation to maximize approval chances.",
    },
  ],
};

export default visa;